import React, { useContext, useEffect, useState } from 'react';
import TopBar from '../Layouts/TopBar';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import SideProject from '../Layouts/SideProject';
import instance from '../Config/AxiosConfig';
import { AuthContext } from '../Context/AuthProvider';
import Cookies from 'js-cookie';
import { Modal } from 'react-bootstrap';
import Swal from 'sweetalert2';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
function ProjectDetails() { 
  const [projectDetails, setProjectDetails] = useState([]);
  const { id } = useParams();
  const { user } = useContext(AuthContext);
  useEffect(() => {
    axios.get(` https://go.vecos.us/reunice/API/v1/projects/get/${id}`)
      .then(response => {
        setProjectDetails(response.data);

      })
      .catch(error => {
        console.error('Erreur lors de la récupération des données:', error);
      });
   }, []);

  const [deleteCom, setDeleteCom] = useState('')
  const handledelete = (id) => {
    instance.get(`/projectComments/delete/${id}`)
      .then(response => {
        setDeleteCom(response.data)

      })
      .catch(error => {
        console.error('Erreur lors de la récupération des données:', error);
      });
  }
  const [comments, setComments] = useState([])
  const [createComment, setCreateComment] = useState({})
  const [formData, setFormData] = useState({
    projectId: '',
    comment: '',

  });
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const token = Cookies.get('token');
    const data = new FormData();
    data.append('projectId', id);
    data.append('comment', formData.comment);
    try {
      const response = await instance.post('/projectComments/add', data, token);
      if (response.status === 200) {
        setFormData({ comment: '' });
        setCreateComment(response.data)
      }
    }
    catch (error) {
      console.error('Error adding project:', error);
    }
  };

  useEffect(() => {

    instance.get(`/projectComments/getAll/${id}`)
      .then(response => {
        setComments(response.data)
      })
      .catch(error => {
        console.error('Erreur lors de la récupération des données:', error);
      });

  }, [deleteCom, createComment]);

  const [showTasksModal, setShowTasksModal] = useState(false);
  const handleTaskstModalOpen = () => {
    setShowTasksModal(true);
  };

  const handleTasksModalClose = () => {
    setShowTasksModal(false);
  };
  const [showAddMenbreModal, setShowAddMenbreModal] = useState(false);
  const handleAddMenbreModalOpen = () => {
    setShowAddMenbreModal(true);
  };

  const handleAddMenbreModalClose = () => {
    setShowAddMenbreModal(false);
  };


  const [errors, setErrors] = useState({});
  const [success, setSuccess] = useState('');
  const [formDataTask, setFormDataTask] = useState({
    title: '',
    description: '',
    dueDate: '',
    projectId: '',
    status: 'Pending'
  });
  const handleChangeTask = (e) => {
    const { name, value } = e.target;
    setFormDataTask(prevState => ({
      ...prevState,
      [name]: value
    }));
  };
  const validateFormTask = () => {
    const errors = {};
    if (!formDataTask.title) errors.title = 'Task name is required';
    if (!formDataTask.description) errors.description = 'Task description is required';

    if (!formDataTask.dueDate) errors.dueDate = 'start date is required';
    return errors;
  };

  const handleAddTask = async (e) => {
    e.preventDefault();
    const validationErrors = validateFormTask();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    const token = Cookies.get('token');
    const dataa = new FormData();

    dataa.append('title', formDataTask.title);
    dataa.append('projectId', id);
    dataa.append('description', formDataTask.description);
    dataa.append('dueDate', formDataTask.dueDate);
    dataa.append('status', 'Pending');
    // Affiche le contenu de FormData pour vérifier
    try {
      for (let [key, value] of dataa.entries()) {
        console.log(`${key}: ${value}`);
      }
      const response = await instance.post('/tasks/add', dataa, token)

      console.log(response, "nnnnnnnnnn");

      if (response.status === 200) {
        Swal.fire({
          text: "Task added successfully!",
          icon: "success"
        });
        setFormDataTask({ title: '', description: '', dueDate: '', status: 'Pending' });
        setErrors({});
        if (showTasksModal) {
          handleTasksModalClose();
        }
      } else {
        Swal.fire({
          title: "Error!",
          text: "Failed to add task.",
          icon: "error"
        });
        setErrors({ form: 'Failed to add task. Error from server.' });
      }
    } catch (error) {
      console.error("Error while adding task:", error);
      Swal.fire({
        title: "Error!",
        text: "Failed to add task.",
        icon: "error"
      });
    }

  };

  //add membre
  const userId = Cookies.get("userId")
  const [connections, setConnections] = useState([]);

  useEffect(() => {
    axios.get(`https://go.vecos.us/reunice/API/v1/users/get/${userId}`)
      .then(response => {
        setConnections(response.data.connections);
      })
      .catch(error => {
        console.error('Erreur lors de la récupération des connections list:', error);
      });
  }, []);

  const handleInvit = async (idproject) => {
    const token = Cookies.get('token');
    let data = new FormData();
    data.append('id', id);
    data.append('member', idproject);
    try {
      const response = await instance.post('/projects/addMember', data, token)

      if (response.status === 200) {
        Swal.fire({
          position: "top-center",
          icon: "success",
          title: "Member has been successfully added to this project",
          showConfirmButton: false,
          timer: 1500,
          imageWidth: 200,
          imageHeight: 200,
        });

        setConnections(prevInvits => prevInvits.filter(invit => invit.id !== idproject));
      } else {
        alert("error")
      }

    }
    catch (error) {
      console.error('Erreur lors de la récupération des données:', error);
    }

  }
  // État pour la modal de liste des membres
  const [showMembersModal, setShowMembersModal] = useState(false);
  const handleMembersModalOpen = () => setShowMembersModal(true);
  const handleMembersModalClose = () => setShowMembersModal(false);
  // Fonction pour supprimer un membre
  const handleRemove = (memberId) => {
    const token = Cookies.get('token');
    const data = new FormData();
    data.append('member', memberId);
    data.append('id', id);

    instance.post('/projects/deleteMember', data, {
      headers: { 'Authorization': `Bearer ${token}` }
    })
      .then(response => {
        if (response.status === 200) {
          Swal.fire({
            text: "The user has been successfully removed from the project's member list!",
            icon: "success"
          });
          setProjectDetails(prevDetails => ({
            ...prevDetails,
            members: prevDetails.members.filter(member => member.id !== memberId)
          }));
        }
      })
      .catch(error => {
        console.error('Erreur lors de la suppression du membre:', error);
      });
  }; 

  return (
    <>
      <TopBar />
      <main className="mt-3">

        <div className="container">
          <div className="row g-4">

            <div className="col-lg-3">
              <SideProject />
            </div>

            <div className="col-md-8 col-lg-9 vstack gap-4">
              {/* Card START */}
              <div className="card card-body card-overlay-bottom border-0" style={{
                backgroundImage: `url(${projectDetails.image})`,
                backgroundPosition: 'center',
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat'
              }}>

                {/* Card body START */}
                <div className="row g-3 justify-content-between">
                  {/* Date START */}
                  <div className="col-lg-2">
                    <div className="bg-mode text-center rounded overflow-hidden p-1 d-inline-block">
                      <div className="bg-primary p-2 text-white rounded-top small lh-1">{projectDetails.createdAt}</div>

                    </div>
                  </div>
                </div>
                {/* Event name START */}
                <div className="row g-3 justify-content-between align-items-center mt-5 pt-5 position-relative z-index-9">
                  <div className="col-lg-9">
                    <h1 className="h3 mb-1 text-white">{projectDetails.title}</h1>
                    <p style={{ color: 'yellow' }} > <b>Blockchain : </b> {projectDetails.hash}   </p>
                  </div>
                  {/* Button */}
                  <div className="col-sm-6 col-lg-3">
                    <label className="form-label d-block" style={{ color: 'yellow' }}   > <b> Project State </b></label>
                    <button className='btn btn-sm btn-primary'> {projectDetails.status}</button>
                  </div>
                </div>
                {/* Event name END */}
              </div>
              <div className="tab-content mb-0 pb-0">
                <div className="tab-pane fade show active" id="tab-1">
                  <div className="card card-body">
                    {/* Card body START */}
                    <div className="row g-4">
                      {/* info */}
                      <div className="col-12">
                        <p className="mb-0">{projectDetails.description}</p>
                      </div>
                      <div className="col-sm-6 col-lg-6">
                        {/* Timings */}
                        <h5>Timings</h5>
                        <p className="small mb-0">Start Date : {projectDetails.startDate} </p>
                        <p className="small mb-0">End Date : {projectDetails.endDate}</p>
                      </div>
                      {/* Entry Fees */}

                      {/* Category & Type */}
                      <div className="col-sm-6 col-lg-6 ">
                        <span className="btn btn-primary-soft me-3" onClick={handleAddMenbreModalOpen} >
                          <i className="fa-solid fa-plus pe-1" />Add members
                        </span>
       <a className="btn btn-dashed rounded" onClick={handleMembersModalOpen}>
                <i className="bi bi-card-checklist me-1" />  List members     </a>
          
                      </div>
                      <div className="card" style={{ backgroundColor: 'white' }}>
                        <div className="card-body">
                          {/* Feed react START */}
                          <ul className="nav nav-stack py-3 small">
                            {/* <li className="nav-item">
                              <a className="nav-link active" href="#!" data-bs-container="body" data-bs-toggle="tooltip" data-bs-placement="top" data-bs-html="true" data-bs-custom-class="tooltip-text-start" data-bs-title="Frances Guerrero<br> Lori Stevens<br> Billy Vasquez<br> Judy Nguyen<br> Larry Lawson<br> Amanda Reed<br> Louis Crawford"> <i className="bi bi-hand-thumbs-up-fill pe-1" />Liked (4)</a>
                            </li> */}
                            <li className="nav-item">
                              <a className="nav-link" href="#!"> <i className="bi bi-chat-fill pe-1" />Comments( {comments.length})</a>
                            </li>

                            {/* Card share action END */}
                          </ul>

                          <div className="d-flex mb-3">

                            <div className="avatar avatar-xs me-2">
                              <a href="#!"> <img className="avatar-img rounded-circle" src={user && user.profilePicture} alt=" " /> </a>
                            </div>

                            <form className="nav nav-item w-100 position-relative" onSubmit={handleSubmit}>
                              <textarea name="comment"
                                value={formData.comment}

                                onChange={handleChange} data-autoresize className="form-control pe-5 bg-light" rows={1} placeholder="Add a comment..." defaultValue={""} />
                              <button className="nav-link bg-transparent px-3 position-absolute top-50 end-0 translate-middle-y border-0" type="submit">
                                <i className="bi bi-send-fill"> </i>
                              </button>
                            </form>

                          </div>
                          <ul className="comment-item-nested list-unstyled">

                            {

                              comments &&
                              comments.map((com, i) => {
                                return (
                                  <>
                                    <li className="comment-item">
                                      <div className="d-flex">
                                        {/* Avatar */}
                                        <div className="avatar avatar-xs">
                                          <a href="#!"><img className="avatar-img rounded-circle" src={com.user.profilePicture} alt="" /></a>
                                        </div>
                                        {/* Comment by */}
                                        <div className="ms-2 w-100" >
                                          <div className="bg-light p-3 rounded">
                                            <div className="d-flex justify-content-between">
                                              <h6 className="mb-1"> <a href="#!">  {com.user.username}</a> </h6>
                                              {/* <small className="ms-2">2hr</small> */}
                                            </div>
                                            <p className="small mb-0">{com.comment}.</p>
                                          </div>
                                          <ul className="nav nav-divider py-2 small d-flex justify-content-end">
                                            <li className="nav-item" onClick={() => handledelete(com.id)}>
                                              <a className="nav-link" href="#!"> delete</a>
                                            </li>
                                           
                                          </ul >
                                        </div>
                                      </div>
                                    </li>
                                  </>

                                )
                              })}
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="tab-pane fade" id="tab-2">
                  <div className="row">
                    <div className="col-sm-6 d-flex offset-6 " onClick={handleTaskstModalOpen}>
                      <a className="btn btn-dashed rounded w-100" href="#!"> <i className="bi bi-plus-circle-dotted me-1" />Add Task</a>
                    </div>
                  </div>
                  <div className="card card-body h-100 mt-md-4">

                    <div className="row g-4">
                      <div className="card-header d-sm-flex  border-0 pb-0">
                        <h2 className="h4 card-title">Discover Tasks</h2>
                      </div>
                      {projectDetails && projectDetails.tasks ? projectDetails.tasks.map((item, index) => (
                        <div key={index} className="col-sm-6 mt-3">
                          <div className="card">
                            <div className="card-body">
                              <h3 className="text-center" >{item.title}</h3>
                              <p className="mb-0">{item.description}</p>
                              <div className="mt-3">
                                <h6>Date :</h6>
                                <p className="small mb-0">{item.createdAt}</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      )) :

                        <>
                          <div className="my-sm-5 py-sm-5 text-center">
                            <i className="display-1 text-body-secondary bi bi-people"> </i>
                            <h4 className="mt-2 mb-3 text-body">No tasks founds</h4>
                            <button className="btn btn-primary-soft btn-sm" data-bs-toggle="modal" data-bs-target="#modalCreateGroup"> Click here to add </button>
                          </div>
                        </>
                      }
                    </div>
                  </div>
                </div>
                {/*end sara */}
              </div>
              <div className="tab-pane fade" id="tab-3">
                <div className="card">
                  <div className="card-header d-sm-flex align-items-center justify-content-between border-0 pb-0">
                    <h5 className="card-title mb-sm-0">Members</h5>
                  </div>

                  <div className="card-body">
                    {projectDetails && projectDetails.members && projectDetails.members.map((item, index) => (

                      < div key={index} className=" d-md-flex align-items-center mb-4 mt-3" >

                        < div className="avatar me-3 mb-3 mb-md-0" >
                          <img className="avatar-img rounded-circle" src={item.profilePicture} />
                        </div>

                        < div className="w-100" >
                          <div className="d-sm-flex align-items-start">
                            <h6 className="mb-0"><a href="#!">{item.firstName} </a></h6>
                          </div>
                        </div>
                        <div className="ms-md-auto d-flex">

                          <a className='text-dark' href='/messaging' > <button className="btn btn-primary-soft btn-sm mb-0"> Message </button>
                          </a>  </div>
                      </div>
                    ))}

                  </div>
                </div>
              </div>
              {
                showTasksModal &&
                <>
                  <Modal show={showTasksModal} onHide={handleTasksModalClose} style={{ marginTop: "50px" }}>
                    <Modal.Header closeButton>
                      <Modal.Title>Add Task</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      {errors.form && <p style={{ color: 'red' }}>{errors.form}</p>}
                      {success && <p style={{ color: 'green' }}>{success}</p>}

                      <form className="row g-3" >
                        {/* Task name */}
                        <div className="col-12">
                          <label className="form-label">Task name</label>
                          <input
                            type="text"
                            className="form-control"
                            name="title"
                            value={formDataTask.title}
                            onChange={handleChangeTask}
                            placeholder="Task name (Required)"
                          />
                          {errors.title && <small style={{ color: 'red' }}>{errors.title}</small>}
                        </div>

                        {/* Task description */}
                        <div className="col-12">
                          <label className="form-label">About Task</label>
                          <textarea
                            className="form-control"
                            name="description"
                            value={formDataTask.description}
                            onChange={handleChangeTask}
                            rows={3}
                            placeholder="Description (Required)"
                          />
                          {errors.description && <small style={{ color: 'red' }}>{errors.description}</small>}
                        </div>

                        {/* Divider */}
                        <hr />

                        {/* Date fields */}
                        <div className="col-12">
                          <h5 className="card-title mb-0">Date</h5>
                        </div>

                        <div className="col-sm-6">
                          <label className="form-label">Date d'échéance</label>
                          <input
                            type="date"
                            className="form-control"
                            name="dueDate"
                            value={formDataTask.dueDate}
                            onChange={handleChangeTask}
                          />
                          {errors.dueDate && <small style={{ color: 'red' }}>{errors.dueDate}</small>}
                        </div>


                        {/* Button */}
                        <div className="col-12 text-end mt-5">
                          <button type="button" className="btn btn-primary mb-0" onClick={handleAddTask}>Add tasks</button>
                        </div>
                      </form>
                    </Modal.Body>
                  </Modal>
                </>
              }
  
            {/* Modal de liste des membres */}
            <Modal show={showMembersModal} onHide={handleMembersModalClose} style={{ marginTop: "50px" }}>
                <Modal.Header closeButton>
                  <Modal.Title>Liste des membres du projet</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <div className="card">
                    <div className="card-body">
                      {projectDetails.members && projectDetails.members.length > 0 ? (
                        projectDetails.members.map((item, index) => (
                          <div key={index} className="d-md-flex align-items-center mb-4 mt-3">
                            <div className="avatar me-3 mb-3 mb-md-0">
                              <img className="avatar-img rounded-circle" src={item.profilePicture} alt={item.firstName} />
                            </div>
                            <div className="w-100">
                              <div className="d-sm-flex align-items-start">
                                <h6 className="mb-0">
                                  <a href="#!">{item.firstName} {item.lastName}</a>
                                </h6>
                              </div>
                            </div>
                            <div className="ms-md-auto d-flex">
                              <a className='text-dark' href='/messaging'>
                                <button className="btn btn-primary-soft btn-sm mb-0 me-2"> Message </button>
                              </a>
                              <button
                                className="btn btn-danger-soft btn-sm mb-0 ms-2"
                                onClick={() => handleRemove(item.id)}
                              >
                                REMOVE
                              </button>
                            </div>
                          </div> 
                        ))
                      ) : (
                        <div className="text-center">
                          <i className="display-1 text-body-secondary bi bi-people"></i>
                          <h4 className="mt-2 mb-3 text-body"> No members found</h4>
                        </div>
                      )}
                    </div>
                  </div>
                </Modal.Body>
              </Modal>
              {/* modal add membre */}
              <Modal show={showAddMenbreModal} onHide={handleAddMenbreModalClose} style={{ marginTop: "50px" }}>
                <Modal.Header closeButton>
                  <Modal.Title>Invite members to join a project</Modal.Title>
                </Modal.Header>
                <Modal.Body>

                  <div className="card">
                    {/* Card header START */}
                    <div className="card-header border-0 pb-0">
                    </div>
                    <div className="card-body">
                      {connections.length !== 0 ?
                        connections.map((item, index) => (
                          <>
                            <div key={index} className="d-md-flex align-items-center mb-4">
                              <div className="avatar avatar-story avatar-l me-3 mb-3 mb-md-0">
                                <a href="#!"> <img className="avatar-img rounded-circle" src={item.profilePicture} alt={item.acronym} /> </a>
                              </div>
                              <div className="w-100">
                                <div className="d-sm-flex align-items-start">
                                  <h6 className="mb-0"><a href="#!">{item.firstName} {item.lastName} </a></h6>
                                  <p className="small ms-sm-2 mb-0">{item.universityName} </p>
                                </div>
                              </div>
                              <div className="ms-md-auto d-flex">
                          {/* Check if projectDetails.members exists and if the user is not already a member */}
                          {projectDetails.members && 
                            !projectDetails.members.some(member => member.id === item.id) && (
                        <button className="btn btn-success-soft btn-sm mb-0 me-2" onClick={() => handleInvit(item.id)} > Add </button>
  )}
</div>
                            </div>
                          </>

                        ))
                        :
                        <>
                          <div className="text-center">
                            <i className="display-1 text-body-secondary bi bi-people"> </i>
                            <h4 className="mt-2 mb-3 text-body">No connections founds</h4>
                          </div>
                        </>
                      }
                    </div>
                  </div>

                </Modal.Body>
              </Modal>
            </div>
          </div>
        </div>
        {/* Container END */}
      </main >
    </>
  );
}
export default ProjectDetails; 
